import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'

interface Tutor {
  email: string
  lastFetchedAt: string | null
  first_name: string
  last_name: string
  description: string
  photo: string
  role: 'tutor' | 'moderator'
  janus_secret: string
  id: number
  price_per_h: number
}

export interface TutorReducer extends Tutor {
  isLoading: boolean
}

const initialState: TutorReducer = {
  email: '',
  lastFetchedAt: null,
  first_name: '',
  last_name: '',
  description: '',
  isLoading: false,
  photo: '',
  role: 'tutor',
  janus_secret: '',
  id: 0,
  price_per_h: 0
}

export const FETCH_TUTOR = createAction('tutor_reducer/fetch_tutor')
export const FETCH_TUTOR_SUCCESS = createAction<Tutor>('tutor_reducer/fetch_tutor_success')
export const FETCH_TUTOR_FAIL = createAction('tutor_reducer/fetch_tutor_failure')

type UpdateTutorPayload = Partial<Tutor>
export type UpdateTutorActionType = PayloadAction<UpdateTutorPayload>
export const UPDATE_TUTOR = createAction<UpdateTutorPayload>('tutor_reducer/update_tutor')
export const UPDATE_TUTOR_SUCCESS = createAction<Tutor>('tutor_reducer/update_tutor_success')
export const UPDATE_TUTOR_FAIL = createAction('tutor_reducer/update_tutor_failure')

interface CreateTutorPayload {
  first_name: string
  last_name: string
  email: string
}
export type CreateTutorActionType = PayloadAction<CreateTutorPayload>
export const CREATE_TUTOR = createAction<CreateTutorPayload>('tutor_reducer/create_tutor')
export const CREATE_TUTOR_SUCCESS = createAction<Tutor>('tutor_reducer/create_tutor_success')
export const CREATE_TUTOR_FAIL = createAction('tutor_reducer/create_tutor_failure')

export const tutorReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_TUTOR_SUCCESS, (state, action) => {
      return { ...state, ...action.payload, lastFetchedAt: new Date().toISOString() }
    })
    .addCase(UPDATE_TUTOR_SUCCESS, (state, action) => {
      return { ...state, ...action.payload, isLoading: false }
    })
    .addCase(UPDATE_TUTOR, (state, action) => {
      return { ...state, isLoading: true }
    })
    .addCase(UPDATE_TUTOR_FAIL, (state, action) => {
      return { ...state, isLoading: false }
    })
})
